import React from 'react';
import './_styles.scss';
import Asset from '../../../../../src/requests/apa/Asset';
import { getStatusPlay } from '../../../utls/utils';


function CardMatches(match) {
  return (
    <div className={'card card-matches'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          <div className='card-cover'style={{ backgroundImage: `url(${Asset.get('match_detail_info_games_img_live_next', '')})` }}>
            <div className='row'>
              <div className='homeParticipant'>
                <img src={match.hpFlag} alt="Country flag" />
                <div className='hpAlign'>
                  <span className='nameCountry'>{match.hpCountryName}</span>
                </div>
              </div>
              <div className='versus'>
                <span className='text-vs'> VS</span>               
              </div>
              <div className='awayParticipant'>
                <img src={match.apFlag} alt="Country flag" />
                <div className='apAlign'>
                  <span className='nameCountry'>{match.apCountryName}</span>
                </div>
              </div>
            </div>
          </div>
          <div className={match.currentPeriod !== undefined ? 'textStatusScheduled' : 'textStatus' }>
            <span className='dateAndTimeInfo'>{getStatusPlay(match.currentPeriod,  match.scheduledStartTimeUTC)}</span>
          </div>
        </div>
      </div>
  </div>
  );
}

export default CardMatches;



// WEBPACK FOOTER //
// ./src/mundial/RibbonTypes/CardsTypesMundial/MatchesCard/index.js